import { handleActions } from "redux-actions";
import { AnyAction } from "redux";

import actionTypes from "./actions";
import { GSCReportReducerInterface } from "./types";

const INIT_STATE: GSCReportReducerInterface = {
    selectedDomain: {
        label: "",
        value: ""
    },
    reportData: {
        isLoading: false,
        error: null,
        result: null
    },
    downloadReportData: {
        isLoading: false,
        error: null,
        result: null
    },
    savedViewsList: {
        isLoading: false,
        error: null,
        result: null
    },
    createSavedView: {
        isLoading: false,
        error: null,
        result: null
    },
    updateSavedView: {
        isLoading: false,
        error: null,
        result: null
    },
    deleteSavedView: {
        isLoading: false,
        error: null,
        result: null
    },
    gscTenantDetails: {
        isLoading: false,
        error: null,
        result: null
    }
};

const Reducer = handleActions(
    {
        [actionTypes.SET_SELECTED_DOMAIN]: (state, action: AnyAction) => ({
            ...state,
            selectedDomain: action.payload
        }),
        [actionTypes.SET_GSC_REPORT_DATA]: (state, action: AnyAction) => ({
            ...state,
            reportData: action.payload
        }),
        [actionTypes.SET_DOWNLOAD_GSC_REPORT_DATA]: (state, action: AnyAction) => ({
            ...state,
            downloadReportData: action.payload
        }),
        [actionTypes.SET_GSC_SAVED_VIEWS_LIST]: (state, action: AnyAction) => ({
            ...state,
            savedViewsList: action.payload
        }),
        [actionTypes.SET_CREATE_GSC_SAVED_VIEW]: (state, action: AnyAction) => ({
            ...state,
            createSavedView: action.payload
        }),
        [actionTypes.SET_UPDATE_GSC_SAVED_VIEW]: (state, action: AnyAction) => ({
            ...state,
            updateSavedView: action.payload
        }),
        [actionTypes.SET_DELETE_GSC_SAVED_VIEW]: (state, action: AnyAction) => ({
            ...state,
            deleteSavedView: action.payload
        }),
        [actionTypes.SET_GSC_TENANT_DETAILS]: (state, action: AnyAction) => ({
            ...state,
            gscTenantDetails: action.payload
        })
    },
    INIT_STATE
);

export default Reducer;
